__webpack_require__.p = "https://data-import-system-frontend.studyportals.eu/dist/";